import{createSelector,createEntityAdapter} from "@reduxjs/toolkit";
import {apiSlice} from "../api/apiSlice";

const rolesAdapter = createEntityAdapter({
  // Assume IDs are stored in a field other than `book.id`
  selectId: x => x .rolId,

  // Keep the "all IDs" array sorted based on book titles
  // sortComparer: (a, b) => a.title.localeCompare(b.title),
})

const initialState = rolesAdapter.getInitialState();

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getRoles: builder.query({
      query: ()=> 'roles',
      transformResponse: responseData=>{
        return rolesAdapter.setAll(initialState, responseData)
      },
      providesTags: (result, error, arg)=>[
        {type:'Roles', id: 'LIST'},
        ...(result?.ids || []).map( id => ({type:'Roles', id}))
      ]
    }),
    addRol: builder.mutation({
      query: (newRol)=>({
        url: 'roles',
        method: 'post',
        body: newRol
      }),
      invalidatesTags: ["Roles", "PermisosRolesMap", "Permisos"]
    }),
    editRol: builder.mutation({
      query: (rolUpdated)=>({
        url: 'roles',
        method: 'put',
        body: rolUpdated
      }),
      invalidatesTags: ["PermisosRolesMap", "Roles", "Permisos"]
    }),
    deleteRol: builder.mutation({
      query: (idsRolesToDelete)=>({
        url: 'roles',
        method: 'delete',
        body: idsRolesToDelete
      }),
      invalidatesTags: ["Roles", "PermisosRolesMap"]
    }),
  })
});

export const { useGetRolesQuery, useAddRolMutation, useEditRolMutation, useDeleteRolMutation } = extendedApiSlice;

//A: returns the query result object
export const selectRolesResut= extendedApiSlice.endpoints.getRoles.select();

//A: created memoized selector
const selectRolesData = createSelector(
  selectRolesResut,
  rolesResult => rolesResult.data  //A: normalized state object with ids and entities
);


//getSelectors creates these selectors and we rename them with aliases using destructuring
export const{
  selectAll: selectAllRoles,
  selectById: selectRolesById,
  selectIds: selectRolesIds
}= rolesAdapter.getSelectors( state => selectRolesData(state) ?? initialState );